import { Injectable , Inject} from '@angular/core';
import { HttpClient , HttpHeaders } from '@angular/common/http';
import { Observable , throwError  } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { APIService } from './api.service'

@Injectable({
  providedIn: 'root'
})
export class CandidatesService extends APIService{
  constructor(http: HttpClient,router :Router) {
    super(http)
    this.endPoint = "candidates"
  }

  get(id){
  	return this.http.get(this.url+`/${id}`,this.httpOptions)
	}

  login(record){
    return this.http.post(this.url+`/login`,record,this.httpOptions)
  }

  register(record){
    return this.http.post(this.url+`/register`,record,this.httpOptions)
  }

  updatePassword(record){
    return this.http.post(this.url+`/update-password`,record,this.httpOptions)
  }

  resetPassword(record){
    return this.http.post(this.url+`/reset-password`,record,this.httpOptions)
  }

  update(record,id){
    return this.http.put(this.url+`/${id}`,record,this.httpOptions);
  }

  // Professional Experience
  addProfExp(record,id){
    return this.http.post(this.url+`/${id}/prof-experience`,record,this.httpOptions);
  }

  updateProfExp(record,id,PID){
    return this.http.put(this.url+`/${id}/prof-experience/${PID}`,record,this.httpOptions);
  }

  deleteProfExp(id,PID){
    return this.http.delete(this.url+`/${id}/prof-experience/${PID}`,this.httpOptions);
  }

  // Education
  addEducation(record,id){
    return this.http.post(this.url+`/${id}/education`,record,this.httpOptions);
  }

  updateEducation(record,id,PID){
    return this.http.put(this.url+`/${id}/education/${PID}`,record,this.httpOptions);
  }

  deleteEducation(id,PID){
    return this.http.delete(this.url+`/${id}/education/${PID}`,this.httpOptions);
  }

  // Skills (candidate-level)
  getPersonalSkills(id){
    return this.http.get(this.url+`/${id}/personal-skills`,this.httpOptions);
  }
  addPersonalSkill(record,id){
    return this.http.post(this.url+`/${id}/personal-skills`,record,this.httpOptions);
  }

  updatePersonalSkill(record,id,PID){
    return this.http.put(this.url+`/${id}/personal-skills/${PID}`,record,this.httpOptions);
  }

  deletePersonalSkill(id,PID){
    return this.http.delete(this.url+`/${id}/personal-skills/${PID}`,this.httpOptions);
  }

  // Reference
  addReference(record,id){
    return this.http.post(this.url+`/${id}/references`,record,this.httpOptions);
  }

  updateReference(record,id,PID){
    return this.http.put(this.url+`/${id}/references/${PID}`,record,this.httpOptions);
  }

  deleteReference(id,PID){
    return this.http.delete(this.url+`/${id}/references/${PID}`,this.httpOptions);
  }

  // Language
  addLanguage(record,id){
    return this.http.post(this.url+`/${id}/languages`,record,this.httpOptions);
  }

  updateLanguage(record,id,PID){
    return this.http.put(this.url+`/${id}/languages/${PID}`,record,this.httpOptions);
  }

  deleteLanguage(id,PID){
    return this.http.delete(this.url+`/${id}/languages/${PID}`,this.httpOptions);
  }

  //ProfCert
  addProfCert(record,id){
    return this.http.post(this.url+`/${id}/professional_certificates`,record,this.httpOptions);
  }

  updateProfCert(record,id,PID){
    return this.http.put(this.url+`/${id}/professional_certificates/${PID}`,record,this.httpOptions);
  }

  deleteProfCert(id,PID){
    return this.http.delete(this.url+`/${id}/professional_certificates/${PID}`,this.httpOptions);
  }

  //Voluntary
  addVoluntary(record,id){
    return this.http.post(this.url+`/${id}/voluntary`,record,this.httpOptions);
  }

  updateVoluntary(record,id,PID){
    return this.http.put(this.url+`/${id}/voluntary/${PID}`,record,this.httpOptions);
  }

  deleteVoluntary(id,PID){
    return this.http.delete(this.url+`/${id}/voluntary/${PID}`,this.httpOptions);
  }

  //Interest

  addInterest(record,id){
    return this.http.post(this.url+`/${id}/interests`,record,this.httpOptions);
  }

  updateInterest(record,id,PID){
    return this.http.put(this.url+`/${id}/interests/${PID}`,record,this.httpOptions);
  }

  deleteInterest(id,PID){
    return this.http.delete(this.url+`/${id}/interests/${PID}`,this.httpOptions);
  }

  generateID(id){
    return this.http.get(this.url+`/${id}/generateID`,this.httpOptions)
  }

  uploadImage(image,id){
/*    var headers = new HttpHeaders();
      headers.append('Content-Type', 'multipart/form-data');
      headers.append('Accept', 'application/json');*/
    return this.http.post(this.url+`/${id}/uploading-image`,image);
  }

  applyToJob(id,v_id){
    return this.http.post(this.url+`/${id}/vacancies?v_id=${v_id}`,{v_id:v_id},this.httpOptions);
  }

  activateEmail(id){
    return this.http.get(this.url+`/${id}/activate-account`,this.httpOptions)
  }
}
